import {useAuth} from '../../../auth'
import {parseJwt} from '../../core/helper'

export const getCreateStoreProperties = (activeRetailer) => {
  const getActiveRetailerCountryInfo = (activeRetailer) => {
    switch (activeRetailer?.id) {
      case 1:
        return {countryCode: 'CH', countryName: 'Switzerland'}
      case 2:
        return {countryCode: 'DE', countryName: 'Germany'}
      case 3:
        return {countryCode: 'LU', countryName: 'Luxembourg'}
    }
  }
  const createStoreProperties = [
    {
      name: 'Store Number',
      slug: 'refNumber',
      order: 2,
      data: null,
      isMandatory: true,
    },
    {
      name: 'GLN',
      slug: 'storeGln',
      order: 3,
      data: null,
      isMandatory: true,
    },
    {
      name: 'Name',
      slug: 'name',
      order: 4,
      data: null,
      isMandatory: true,
    },
    {
      name: 'Language',
      slug: 'language',
      order: 5,
      data: [{type: 'EN'}, {type: 'DE'}, {type: 'FR'}, {type: 'IT'}],
      isMandatory: true,
    },
    {
      name: 'Retailer',
      slug: 'retailer',
      order: 6,
      data: null,
      default: activeRetailer?.name,
      disabled: true,
      isMandatory: true,
    },
    {
      name: 'Street Name',
      slug: 'streetName',
      order: 6,
      data: null,
    },
    {
      name: 'House Number',
      slug: 'houseNumber',
      order: 6,
      data: null,
    },
    {
      name: 'City',
      slug: 'city',
      order: 6,
      data: null,
    },
    {
      name: 'Postal Code',
      slug: 'postalCode',
      order: 6,
      data: null,
    },
    {
      name: 'Country Code',
      slug: 'countryCode',
      order: 6,
      data: null,
      isMandatory: true,
      default: getActiveRetailerCountryInfo(activeRetailer)?.countryCode ?? '',
      disabled: true,
    },
    {
      name: 'Country Name',
      slug: 'countryName',
      order: 6,
      data: null,
      default: getActiveRetailerCountryInfo(activeRetailer)?.countryName ?? '',
      disabled: true,
    },
    {
      name: 'State Code',
      slug: 'stateCode',
      order: 6,
      data: null,
    },
    {
      name: 'State Name',
      slug: 'stateName',
      order: 6,
      data: null,
    },
    {
      name: 'Store Format',
      slug: 'storeFormat',
      order: 6,
      data: [
        {type: 'E'},
        {type: 'P'},
        {type: 'A'},
        {type: 'T'},
        {type: 'D'},
        {type: 'G'},
        {type: 'F'},
        {type: 'C'},
        {type: 'W'},
      ],
    },
    {
      name: 'Operator Model',
      slug: 'operatorModel',
      order: 6,
      data: [
        {type: 'AG'},
        {type: 'DE'},
        {type: 'ES'},
        {type: 'FR'},
        {type: 'OH'},
        {type: 'FL'},
        {type: 'LV'},
        {type: 'BU'},
      ],
    }/*,
    {
      name: 'Daily Trading Limit',
      slug: 'dailyTradingLimit',
      order: 6,
      data: null,
    },
    {
      name: 'Sap Service Tags',
      slug: 'sapServiceTags',
      order: 6,
      data: null,
    },*/
  ]
  return createStoreProperties
}
